const cardItems = [
  {
    id: 1,
    tag: '编辑精选',
    title: '那些被低估的国产科幻片',
    desc: '除了大制作，这些中小成本科幻片同样值得一看，想象力不输好莱坞。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20scene%20with%20warm%20golden%20and%20amber%20tones%2C%20dramatic%20lighting%20through%20windows%2C%20film%20aesthetic%2C%20mysterious%20mood%2C%20elegant%20composition%2C%20no%20text%20no%20people&width=600&height=340&seq=cards-01&orientation=landscape',
  },
  {
    id: 2,
    tag: '本周热映',
    title: '暑期档动画电影全家欢指南',
    desc: '带着孩子一起走进电影院般的观影体验，精选五部合家欢动画。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20cinematic%20animation%20style%20scene%20with%20warm%20sunlight%2C%20whimsical%20atmosphere%2C%20soft%20pastel%20and%20golden%20tones%2C%20dreamy%20film%20aesthetic%2C%20no%20text%20no%20people&width=600&height=340&seq=cards-02&orientation=landscape',
  },
  {
    id: 3,
    tag: '深度影评',
    title: '从《沙丘》看科幻史诗的叙事艺术',
    desc: '维伦纽瓦如何用影像语言重构经典，一部科幻电影的视觉与叙事突破。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20desert%20landscape%20with%20warm%20golden%20sand%20dunes%2C%20dramatic%20atmospheric%20lighting%2C%20film%20cinema%20aesthetic%2C%20vast%20scale%2C%20professional%20movie%20photography%2C%20no%20text%20no%20people&width=600&height=340&seq=cards-03&orientation=landscape',
  },
  {
    id: 4,
    tag: '新片速递',
    title: '八月院线新片完整片单一览',
    desc: '动作、悬疑、动画全面开花，这个八月注定是影迷的狂欢季。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20interior%20with%20warm%20theater%20lighting%2C%20empty%20red%20seats%2C%20elegant%20atmosphere%2C%20film%20premiere%20aesthetic%2C%20dramatic%20spotlight%2C%20professional%20photography%2C%20no%20text%20no%20people&width=600&height=340&seq=cards-04&orientation=landscape',
  },
  {
    id: 5,
    tag: '经典重温',
    title: '十部改变电影史的伟大作品',
    desc: '从《公民凯恩》到《教父》，这些电影定义了电影艺术的高度。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20black%20and%20white%20cinematic%20scene%20with%20dramatic%20lighting%2C%20classic%20hollywood%20aesthetic%2C%20film%20noir%20atmosphere%2C%20elegant%20shadows%2C%20nostalgic%20mood%2C%20no%20text%20no%20people&width=600&height=340&seq=cards-05&orientation=landscape',
  },
  {
    id: 6,
    tag: '观影指南',
    title: '如何用极速影视打造家庭影院',
    desc: '选片、设备、氛围一步到位，把客厅变成你的私人电影院。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20warm%20ambient%20lighting%2C%20large%20screen%20glowing%2C%20comfortable%20living%20room%20atmosphere%2C%20cinematic%20evening%20mood%2C%20elegant%20interior%2C%20no%20text%20no%20people&width=600&height=340&seq=cards-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500">编辑团队为你精心挑选的优质影视内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}